<template>
  <div>
    <h2 v-if="!embedded">
      <v-icon color="accent">{{icono}}</v-icon>
      {{titulo}}
    </h2>

    <v-layout row wrap>
    <v-flex xs12 sm4 md12 v-if="!embedded">
      <v-btn color="success" small xs2 @click="$router.push('/tracks/0')">
        <v-icon small left dark>fas fa-plus</v-icon>
        <span>Agregar</span>
      </v-btn>
      <v-btn color="info" small @click="gridOptions.api.exportDataAsCsv(exportParams)" :disabled="registros && registros.length <= 0">
        <v-icon small left dark>fas fa-file-excel</v-icon>
        <span>Exportar</span>
      </v-btn>
      <v-btn color="accent" small @click="realtime()">
        <v-icon small left dark>fas fa-sync</v-icon>
        <span>Realtime</span>
      </v-btn>
    </v-flex>
    </v-layout>

    <ag-grid-vue style="width: 100%" :style="{height: getHeight}" class="ag-theme-material elevation-1"
      :gridOptions="gridOptions" :rowData="registros" :columnDefs="columnDefs" rowHeight="110">
    </ag-grid-vue>

  </div>

</template>

<script>
import Vue from 'vue'
import DateFormatComponent from '../shared/DateFormatComponent'
import ListOptionsComponent from '../shared/ListOptionsComponent'
import CoordenadasComponent from '../shared/CoordenadasComponent'
import UbicacionComponent from '../shared/UbicacionComponent'
import helper from '../../plugins/helper'
import Tracks from '../../services/tracks'
import {AgGridVue} from 'ag-grid-vue';

//Vue.use(AgGridVue)

export default {
  name: 'TracksLista',
  props: ['embedded'],
  data () {
    return {
      titulo: 'Tracks',
      icono: 'fas fa-map-marker-alt',
      registros: null,
      loading: true,
      totalItems: 0,
      gridOptions: {
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        pagination: true,
        localeText: helper.localeText,
      },
      columnDefs: null,
      exportParams: {
        fileName: 'eyehunter_tracks.csv',
        columnSeparator: ';',
        columnKeys: ['ubicacion','velocidad','fecha','mensaje','bateria','distancia','tiempo','valido']
      }
    }
  },
  components: {
    'ag-grid-vue': AgGridVue,
    'check-component': {
        template: `<div>
        <v-icon v-if="params.value" color="success" small>far fa-check-circle</v-icon>
        <v-icon v-if="!params.value" color="error" small>far fa-times-circle</v-icon>
        </div>`
    }
  },
  computed: {
    getHeight: function() {
      if (!this.embedded) {
        return '495px'
      } else {
        return '240px'
      }
    }
  },
  methods: {
    createColumnDefs() {
      this.columnDefs= [
        {
          headerName:  ' ',
          cellRendererFramework: ListOptionsComponent,
          cellRendererParams: { modulo: 'tracks' },
          width: 70
        },
        {
          headerName: 'Vehiculo',
          width: 150,
          field: 'vehiculo.nombre'
        },
        {
          headerName: 'Coordenadas',
          cellRendererFramework: CoordenadasComponent,
          width: 180
        },
        {
          headerName: 'Ubicacion',
          cellRendererFramework: UbicacionComponent,
          width: 210
        },
        {
          headerName: 'Valido',
          cellRendererFramework: 'check-component',
          field: 'valido',
          width: 150
        },
        {
          headerName: 'Velocidad',
          field: 'velocidad',
          width: 130
        },
        {
          headerName: 'Fecha',
          field: 'fecha',
          cellRendererFramework: DateFormatComponent,
          width: 150
        },
        {
          headerName: 'Mensaje',
          field: 'mensaje',
          width: 160
        },
        {
          headerName: 'Bateria',
          field: 'bateria',
          width: 100
        },
        {
          headerName: 'Distancia',
          field: 'distancia',
          width: 110
        },
        {
          headerName: 'Tiempo',
          field: 'tiempo',
          width: 110
        },
        {
          headerName: 'Creado',
          field: 'fechaCreacion',
          cellRendererFramework: DateFormatComponent,
          width: 150
        },
        {
          headerName: 'Actualizado',
          field: 'fechaActualizacion',
          cellRendererFramework: DateFormatComponent,
          width: 150
        },
        {
          headerName: 'Creado por',
          field: 'usuarioCreacion.username',
          width: 150
        },
      ]
    },
    async realtime() {
      //let token = await this.$getItem('token')
      Vue.sailsConnect(await this.$getItem('token'))
      Vue.io.socket.on('carrier', function gotCarrier (data) {
        console.log('Carrier', data)
      })
    }
  },
  async beforeMount() {
    let res = await Tracks.list({ populate: 'usuarioCreacion,propietario,group,vehiculo' })
    this.registros = res
    this.createColumnDefs()
    this.showGrid = true
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tracks/TracksLista.vue